import InputType from "common/form/InputType";
import { Form, Input } from "decorator-form";

@Form({title: "FFHTMLWidget"})
export default class FFHTMLWidgetConfig {

    public id: string;

    @Input({type: InputType.CHECKBOX, title: "HTML Enabled"})
    public htmlEnabled: boolean = true;
}


// WEBPACK FOOTER //
// ./src/panels/FFHTMLWidget/FFHTMLWidgetConfig.ts